import moment from "moment";
import { MONTHS } from "@/utils/date/months";

export function Timesheet(data) {
    this.id = data.id;

    this.created = moment(data.created_at, "YYYY-MM-DD").format("DD.MM.YYYY");
    this.filial = data.filial.filial_name;

    const period = moment(data.period, "YYYY-MM-DD");
    const year = period.get("year");
    const month = MONTHS[period.get("month")];

    this.period = `${month} ${year}`;
    this.author = data.createdBy.name;
    this.fines = data.penalties;
    this.bonuses = data.bonuses;
    this.paid = data.paid;
}
